import React, { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import PatientPaymentDetail from "./PatientPaymentDetail/PatientPaymentDetail";
import PatientPaymentSearch from "./PatientPaymentSearch/PatientPaymentSearch";
import { useDispatch, useSelector } from "react-redux";
import { mainTab as patientPaymentMainTab } from "Redux/TabsSlice/TabsSelectors";
import { activeMainTab } from "Redux/TabsSlice/TabsSlice";
import SlidingTabs from "Common/SlidingTabs/SlidingTabs";
import RequestPaymentSearch from "./RequestPaymentSearch/RequestPaymentSearch";
import RecurrentPaymentSearch, { recurrentPaymentSubTabs } from "./RecurrentPaymentSearch/RecurrentPaymentSearch";
import RecurrentPaymentSearchForm from "./RecurrentPaymentSearch/RecurrentPaymentSearchForm";
import LayoutWrapper from "Components/LayoutWrapper/LayoutWrapper";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import ParamListGen from "Services/ParamListGen";
import api from "http";
import useFilterCount from "CustomHooks/useFilterCount";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import PatientPaymentForm from "./PatientPaymentForm";
import useDebounce from "CustomHooks/useDebounce";
import Show from "Components/Show/Show";
import AddNewPatientPaymentPopup from "Popups/AddNewPatientPaymentPopup/AddNewPatientPaymentPopup";
import GlobalNavigation from "Common/GlobalNavigationObj";

export const patientPaymentTabs = {
  Payments: "patient payments",
  "Payment Requests": "request payments",
  "Recurrent Payments": "recurrent payments",
};

let initialSearchModel = {
  paymenttype: "PATIENT",
  locationId: "",
  patientId: "",
  paymentId: "",
  paymentSource: "",
  receiptNumber: "",
  CCTransactionId: "",
  CCTransactionStatus: "",
  patientName: "",
  payerName: "",
  checknumber: "",
  checkdatefrom: "",
  checkdateto: "",
  depositdatefrom: "",
  depositdateto: "",
  poststatus: "All",
  entrydatefrom: "",
  entrydateto: "",
  receiveddatefrom: "",
  receiveddateto: "",
  visitid: "",
  posteddatefrom: "",
  posteddateto: "",
  dateType: "Check Date",
};

// let searchModel = structuredClone(initialSearchModel)
let oldPracticeId = null
const paramsModel = {
  param_list: [],
  practiceId: 0,
  perPage: 20,
  pageNo: 1,
  totalPages: 0,
  totalCount: 0,
  isExportCall: false,
};
const PatientPayments = () => {
  const [paramModel, setParamModel] = useState(paramsModel);
  let [searchModel, setSearchModel] = useState(structuredClone(initialSearchModel));
  const [rows, setRows] = useState(null);
  const { filterCount, calculateCount } = useFilterCount();
  const patientPaymentSearchRef = useRef();
  const requestPaymentSearchRef = useRef();
  const recurrentPaymentSearchRef = useRef();
  const mainTab = useSelector(patientPaymentMainTab);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState({
    activePaymentId: null,
    renderedTabs: mainTab?.activeTab
      ? [mainTab?.activeTab]
      : [patientPaymentTabs["Payments"]],
    activeTab: mainTab?.activeTab ?? patientPaymentTabs["Payments"],
  });
  const [superPaymentIdValue, setSuperPaymentIdValue] = useState("");
  const [superRequestIdValue, setSuperRequestIdValue] = useState("")
  const [paymentIdLoader, setPaymentIdLoader] = useState(false);
  const [superSearchPatientValue, setsuperSearchPatientValue] = useState('')
  const [newPatientPaymentPopup, setNewPatientPaymentPopup] = useState(false);
  const [selectedPaymentRow, setSelectedPaymentRow] = useState(null);

  // Recurrent Payment Search State
  const initialRecurrentSearchModel = {
    patientid: null,
    locationId: "",
    status: null,
    accountnum: null,
    totalrecord: 10,
    planType: null,
    totalBalance: null,
    firstPaymentDateFrom: null,
    firstPaymentDateto: null,
    lastPaymentDateFrom: null,
    lastPaymentDateto: null,
    finalpaymentdatefrom: null,
    finalpaymentdateto: null,
    nextBillingDatefrom: null,
    nextBillingDateto: null,
    scheduledDatefrom: null,
    scheduledDateto: null,
    paymentDatefrom: null,
    paymentDateto: null
  };
  const [recurrentSearchModel, setRecurrentSearchModel] = useState(structuredClone(initialRecurrentSearchModel));
  const [recurrentPaymentLoader, setRecurrentPaymentLoader] = useState(false);
  const [superRecurrentAccountValue, setSuperRecurrentAccountValue] = useState("");
  const { filterCount: recurrentFilterCount, calculateCount: calculateRecurrentFilterCount } = useFilterCount();

  const debouncedRecurrentAccountValue = useDebounce(superRecurrentAccountValue, 500);

  const handleFilterSuperSearchRecurrent = (e) => {
    setSuperRecurrentAccountValue(e.target.value);
    setRecurrentSearchModel((prev) => ({
      ...prev,
      accountnum: e.target.value || null,
    }));
  };

  const handleRecurrentPaymentSubmit = (loadMore = false) => {
    if (recurrentPaymentSearchRef.current) {
      recurrentPaymentSearchRef.current.handleSubmit(loadMore);
    }
  };

  const handleRecurrentPaymentClear = () => {
    const activeSubTab = recurrentPaymentSearchRef.current?.activeSubTab;
    const planType = activeSubTab === recurrentPaymentSubTabs["Payment Plans"] ? "BAL" : "SUB";

    const clearedModel = {
      ...initialRecurrentSearchModel,
      planType,
      totalrecord: 10
    };

    setRecurrentSearchModel(clearedModel);
    setSuperRecurrentAccountValue("");
    calculateRecurrentFilterCount([], initialRecurrentSearchModel, '');

    // Pass cleared model directly to handleSubmit
    recurrentPaymentSearchRef.current?.handleSubmit(false, clearedModel);
  };

  const handleRecurrentPaymentChange = (e) => {
    const { name, value } = e.target;
    setRecurrentSearchModel((prev) => ({
      ...prev,
      [name]: value === '' ? null : value,
    }));
  };

  const handlePatientPaymentRefresh = () => {
    handleSubmit(paramModel.perPage, paramModel.pageNo);
  };


  const debouncedSearchTermPayment = useDebounce(superPaymentIdValue, 500);
  const debouncedSearchTermRequest = useDebounce(superRequestIdValue, 500);

  const practiceId = useSelector((state) => state.userAuth.practiceDetails.id) ?? null
  const handleFilterSuperSearchPayment = (e) => {
    setSuperPaymentIdValue(e.target.value)
  }
  const handleFilterSuperSearchRequest = (e) => {
    setSuperRequestIdValue(e.target.value)
  }

  const handleClear = async () => {
    setSearchModel(initialSearchModel);
    setParamModel(paramsModel);
    setsuperSearchPatientValue('');
    searchModel = structuredClone(initialSearchModel);

    handleSubmit(20, 1, null, initialSearchModel);
  };

  const handlePageChange = (pageNo) => {
    setParamModel((prev) => ({
      ...paramModel,
      pageNo
    }))
    handleSubmit(paramModel.perPage, pageNo);
  };
  const handlePerRowsChange = (perPage, pageNo) => {
    setParamModel((prev) => ({
      ...paramModel,
      pageNo,
      perPage,
    }))
    handleSubmit(perPage, pageNo);
  };

  const handleRowsChange = (updatedRows, { indexes }) => {
    const currentRows = [...(rows || [])];
    const index = indexes[0];
    const row = currentRows[index];

    if (row && row.type === "MASTER") {
      if (!row.expanded) {
        // Expand: insert detail row
        currentRows.splice(index + 1, 0, {
          ...row,
          type: "DETAIL",
          id: row.id + 10000,
          parentId: row.id,
        });
        // Update the master row to expanded
        currentRows[index] = { ...row, expanded: true };
      } else {
        // Collapse: remove detail row
        currentRows.splice(index + 1, 1);
        // Update the master row to not expanded
        currentRows[index] = { ...row, expanded: false };
      }
      setRows(currentRows);
    }
  };

  const apiEndPoint =
    activeTab.activeTab === "patient payments"
      ? "/api/patientpayment/v2/FindPatientPayments"
      : "/api/PatientPayment/FindPaymentRequest";


  const handleSubmit = async (
    perPages,
    pageNumbers,
    activeEndPoint = apiEndPoint,
    clearModel
  ) => {


    let apiCallEndpoint = activeEndPoint ?? apiEndPoint;
    let emptyModel = clearModel;
    if (clearModel) {
      emptyModel = {
        ...clearModel,
        paymentSource:
          apiCallEndpoint === "/api/PatientPayment/FindPaymentRequest"
            ? "Payment Request"
            : "",
      };
    }
    try {
      // if (!superPaymentIdValue && !superRequestIdValue) {
      const perPage = perPages || 20;
      const pageNo = pageNumbers || 1;
      setPaymentIdLoader(true);
      let searchModelForAPI = emptyModel ?? {
        ...searchModel,
        paymentSource:
          apiCallEndpoint === "/api/PatientPayment/FindPaymentRequest"
            ? "Payment Request"
            : searchModel.paymentSource,
      };
      if (apiCallEndpoint === "/api/PatientPayment/FindPaymentRequest") {
        const { poststatus, ...searchModelWithoutPostStatus } = searchModelForAPI;
        searchModelForAPI = searchModelWithoutPostStatus;
      }
      let paramList = ParamListGen(searchModelForAPI);
      const payload = {
        param_list: paramList,
        practiceId: 0,
        perPage,
        pageNo,
        totalPages: 0,
        totalCount: 0,
        isExportCall: false,
      };
      const response = await api.post(
        `${process.env.REACT_APP_TC_PMS}${apiCallEndpoint}`,
        payload
      );
      const mappedRows = response.data.dataModel.data.map(row => ({
        ...row,
        type: 'MASTER',
        expanded: false
      }));
      setRows(mappedRows);
      setParamModel((prev) => ({
        ...prev,
        perPage,
        pageNo,
        totalCount: response.data.dataModel.totalCount,
      }));

      calculateCount(paramList, initialSearchModel, activeTab.activeTab === "request payments" ? "paymentSource" : '');
      // } else {
      // if(!clearModel){
      //   searchModel = searchModel
      // }

      // setSuperPaymentIdValue("")
      // setSuperRequestIdValue("")
      // }
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setPaymentIdLoader(false);
    }
  };

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    setSearchModel((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === 'poststatus') {
      const updatedSearchModel = {
        ...searchModel,
        [name]: value,
      };
      handleSubmit(20, 1, null, updatedSearchModel);
    }
  };

  const handlePaymentId = (pidOrRow) => {
    const pid = typeof pidOrRow === "object" && pidOrRow?.paymentId != null ? pidOrRow.paymentId : pidOrRow;
    const row = typeof pidOrRow === "object" && pidOrRow?.paymentId != null ? pidOrRow : null;
    setSelectedPaymentRow(row);
    const patientPaymentKey = GlobalNavigation.find(tab => tab.name === "patient payments")?.key;
    setActiveTab((prev) => ({ ...prev, activePaymentId: pid }));
    const reduxPayload = {
      key: patientPaymentKey,
      name: "patient payments",
      right: true,
      activeTab: activeTab.activeTab,
      title: "Patient Payments",
      data: pid,
    };
    dispatch(activeMainTab(reduxPayload));
  };

  /**
   * handle new patient payment popup
   */
  const openNewPatientPaymentPopup = () => {
    setNewPatientPaymentPopup(true);
  }
  const closeNewPatientPaymentPopup = () => {
    setNewPatientPaymentPopup(false);
    handlePaymentId(null)
  }


  const handleActiveTab = (tab) => {
    const tabKey = patientPaymentTabs[tab];
    if (tabKey === activeTab.activeTab) return;
    setActiveTab((prev) => ({
      ...prev,
      activeTab: tabKey,
      renderedTabs: !prev.renderedTabs.includes(tabKey)
        ? [...prev.renderedTabs].concat(tabKey)
        : prev.renderedTabs,
    }));
    const patientPaymentKey = GlobalNavigation.find(tab => tab.name === "patient payments")?.key;
    const reduxPayload = {
      key: patientPaymentKey,
      name: "patient payments",
      activeTab: tabKey,
      right: true,
      title: "Patient Payments",
      data: null,
    };
    // searchModel = searchModel
    setRows([])
    dispatch(activeMainTab(reduxPayload));
  };

  useEffect(() => {
    if (practiceId !== oldPracticeId) {
      oldPracticeId = practiceId
      // searchModel = initialSearchModel
    }
    // Handle recurrent payment account number search
    if (activeTab.activeTab === patientPaymentTabs["Recurrent Payments"] && recurrentPaymentSearchRef.current) {
      if (debouncedRecurrentAccountValue === "" || debouncedRecurrentAccountValue.length > 2) {
        const currentActiveSubTab = recurrentPaymentSearchRef.current.activeSubTab;
        const planTypeValue = currentActiveSubTab === recurrentPaymentSubTabs["Payment Plans"] ? "BAL" : "SUB";

        setRecurrentSearchModel((prev) => ({
          ...prev,
          accountnum: debouncedRecurrentAccountValue || null,
          planType: debouncedRecurrentAccountValue ? planTypeValue : null
        }));

        // Trigger search after state update
        setTimeout(() => {
          if (recurrentPaymentSearchRef.current) {
            recurrentPaymentSearchRef.current.handleSubmit(false);
          }
        }, 100);
      }
    }
    if (mainTab.data === null) {
      if (debouncedSearchTermPayment === "" || debouncedSearchTermPayment.length > 2 || debouncedSearchTermRequest === "" || debouncedSearchTermRequest > 2) {
        (async () => {
          try {
            setPaymentIdLoader(true)
            const apiEndPoint = activeTab.activeTab === "patient payments" ? "/api/patientpayment/v2/FindPatientPayments" : "/api/PatientPayment/FindPaymentRequest";
            const payloadObjPayment = {
              ...searchModel,
              paymenttype: "PATIENT",
              paymentId: debouncedSearchTermPayment,
              dateType: "Check Date",
            }
            const payloadObjRequest = {
              ...searchModel,
              paymenttype: "PATIENT",
              requestId: debouncedSearchTermRequest,
              dateType: "Check Date",
              paymentSource: ""
            }

            const { poststatus, ...payloadObjRequestWithoutPostStatus } = payloadObjRequest;
            let paramList = ParamListGen(activeTab.activeTab === "patient payments" ? payloadObjPayment : payloadObjRequestWithoutPostStatus)
            const payload = {
              param_list: paramList,
              practiceId: 0,
              perPage: 20,
              pageNo: 1,
              totalPages: 0,
              totalCount: 0,
              isExportCall: false,
            };

            const response = await api.post(`${process.env.REACT_APP_TC_PMS}${apiEndPoint}`, payload)
            const mappedRows = response.data.dataModel.data.map(row => ({
              ...row,
              type: 'MASTER',
              expanded: false
            }));
            setRows(mappedRows);
            setParamModel((prev) => ({
              ...prev,
              perPage: 20,
              pageNo: 1,
              totalCount: response.data.dataModel.totalCount,
            }));
            // calculateCount(paramList, initialSearchModel, activeTab.activeTab === "request payments" ? "paymentSource" : '');
          } catch (error) {

            ErrorHandlingMessage(error)
            // setPatientsList([])
          } finally {
            setPaymentIdLoader(false)
          }
        })();
      }
    } else if (mainTab.name === "patient payments" && mainTab.data) {
      setActiveTab(prev => ({ ...prev, activePaymentId: mainTab.data }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTermPayment, practiceId, activeTab.activeTab, debouncedSearchTermRequest, mainTab.data, mainTab.name, debouncedRecurrentAccountValue])



  return (
    <>
      {paymentIdLoader && activeTab.activeTab !== patientPaymentTabs["Recurrent Payments"] && <FullPageLoader allowFullScreen />}
      <Show when={newPatientPaymentPopup}>
        <AddNewPatientPaymentPopup currentTab={activeTab.activeTab} patientId={null} handleSubmit={handleSubmit} onClose={closeNewPatientPaymentPopup} />
      </Show>
      <ul className=" sticky top-0 z-[2] py-4 flex items-center text-sm  bg-[#F8FAFB] text-secondary font-medium">
        {activeTab.activePaymentId === null ? (
          <li className="mr-6 text-3xl font-semibold">Patient Payments</li>
        ) : (
          <>
            <li>
              <button className={`patientTab`} onClick={() => handlePaymentId(null)}    >    All Payments  </button>
            </li>
            <li className={`patientTab ${activeTab.activePaymentId !== null ? "font-semibold inset-0 text-[#604FF8] bg-white rounded" : ""} `}   >
              {activeTab.activePaymentId === 0 ? activeTab.activeTab === "patient payments" ? "New Payment" : "New Payment Request" : `Payment- ${activeTab.activePaymentId}`}
              <button className="inline hover:scale-125" onClick={() => handlePaymentId(null)}   >
                <X size={14} className="text-[#604FF8]" aria-hidden="true" />
              </button>
            </li>
          </>
        )}
      </ul>
      {(activeTab.activePaymentId === 0 || activeTab.activePaymentId) && (
        <PatientPaymentDetail
          handleReload={(payID) => setActiveTab(prev => ({ ...prev, activePaymentId: payID }))}
          paymentId={activeTab.activePaymentId}
          handlePayment={handlePaymentId}
          parentName="patientPayments"
          patientDetail={null}
          selectedPaymentRow={selectedPaymentRow}
        />
      )}

      {
        activeTab.activePaymentId === null ? (
          <LayoutWrapper>
            {activeTab.activeTab !== patientPaymentTabs["Recurrent Payments"] && (
              <PatientPaymentForm
                activeTab={activeTab.activeTab}
                searchModel={searchModel}
                handlePaymentId={handlePaymentId}
                superSearchPatientValue={superSearchPatientValue} setSuperSearchPatientValue={setsuperSearchPatientValue}
                handleSubmit={handleSubmit}
                handleClear={handleClear}
                onHandleChange={onHandleChange}
                setSearchModel={setSearchModel}
                paramModel={paramModel}
                filterCount={filterCount}
                paymentIdLoader={paymentIdLoader}
                handleFilterSuperSearchPayment={handleFilterSuperSearchPayment}
                superPaymentIdValue={superPaymentIdValue}
                superRequestIdValue={superRequestIdValue}
                handleFilterSuperSearchRequest={handleFilterSuperSearchRequest}
                openNewPatientPaymentPopup={openNewPatientPaymentPopup}
              />
            )}
            <Show when={activeTab.activeTab === patientPaymentTabs["Recurrent Payments"]}>
              <RecurrentPaymentSearchForm
                searchModel={recurrentSearchModel}
                handleSubmit={handleRecurrentPaymentSubmit}
                handleClear={handleRecurrentPaymentClear}
                onHandleChange={handleRecurrentPaymentChange}
                setSearchModel={setRecurrentSearchModel}
                handlePaymentId={handlePaymentId}
                filterCount={recurrentFilterCount}
                loading={recurrentPaymentLoader}
                handleFilterSuperSearch={handleFilterSuperSearchRecurrent}
                superSearchValue={superRecurrentAccountValue}
              />
            </Show>
            <SlidingTabs activeTab={activeTab.activeTab} extraClass="mb-4">
              {Object.keys(patientPaymentTabs).map((tab, index) => {
                const tabKey = patientPaymentTabs[tab];
                const isActive = activeTab.activeTab === tabKey;
                const handleTabClick = () => handleActiveTab(tab);
                return (
                  <button
                    key={index}
                    value={tabKey}
                    className={`text-md cursor-pointer pb-2 ${isActive ? "text-primary" : "text-secondaryLight"}`}
                    onClick={handleTabClick}
                  >
                    {tab}
                  </button>
                );
              })}
            </SlidingTabs>

            <Show when={activeTab.renderedTabs.includes(patientPaymentTabs.Payments)}>
              <Show when={activeTab.activeTab === patientPaymentTabs.Payments && !mainTab.data && mainTab.data !== 0}>
                <PatientPaymentSearch
                  handlePaymentId={handlePaymentId}
                  activeTab={activeTab.activeTab}
                  rows={rows ?? []}
                  patientId={""}
                  ref={patientPaymentSearchRef}
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  paramModel={paramModel}
                  onRowsChange={handleRowsChange}
                  onRefresh={handlePatientPaymentRefresh}
                />
              </Show>
            </Show>

            <Show when={activeTab.renderedTabs.includes(patientPaymentTabs["Payment Requests"])}>
              <Show when={activeTab.activeTab === patientPaymentTabs["Payment Requests"] && !mainTab.data && mainTab.data !== 0}>
                <RequestPaymentSearch
                  rows={rows ?? []}
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  paramModel={paramModel}
                  handlePaymentId={handlePaymentId}
                  patientId=""
                  handleSubmit={handleSubmit}
                  ref={requestPaymentSearchRef}
                />
              </Show>
            </Show>

            <Show when={activeTab.renderedTabs.includes(patientPaymentTabs["Recurrent Payments"])}>
              <Show when={activeTab.activeTab === patientPaymentTabs["Recurrent Payments"] && !mainTab.data && mainTab.data !== 0}>
                <RecurrentPaymentSearch
                  ref={recurrentPaymentSearchRef}
                  handlePaymentId={handlePaymentId}
                  searchModel={recurrentSearchModel}
                  setSearchModel={setRecurrentSearchModel}
                  loader={recurrentPaymentLoader}
                  setLoader={setRecurrentPaymentLoader}
                  calculateFilterCount={calculateRecurrentFilterCount}
                  initialSearchModel={initialRecurrentSearchModel}
                />
              </Show>
            </Show>
          </LayoutWrapper>

        ) : " "
      }
    </>
  );
};

export default PatientPayments;
